import { TabsGroup } from 'ui/tabsGroup';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { PageHeader } from 'ui/pageHeader';
import noop from 'utils/noop';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { NavTitle } from 'modules/frequencyManagement/lib/constants';
import { TabsAndActions } from './TabsAndActions';
import { MainContent } from './MainContent';
import { FullWidthBackground, PageTitle } from './FrequencyManagementPage.styled';

export const FrequencyManagementPage = ({ messageMedium }: { messageMedium: SupportedMediums }) => (
  <>
    <FixedWidth>
      <PageHeader documentTitle="Manage Frequency Settings">
        <PageTitle>{NavTitle}</PageTitle>
      </PageHeader>
    </FixedWidth>
    <TabsGroup value={messageMedium} onValueChange={noop}>
      <TabsAndActions />
      <FullWidthBackground>
        <MainContent messageMedium={messageMedium} />
      </FullWidthBackground>
    </TabsGroup>
  </>
);
